import { render, staticRenderFns } from "./Tiquete.vue?vue&type=template&id=9a994f2c"
import script from "./Tiquete.vue?vue&type=script&lang=js"
export * from "./Tiquete.vue?vue&type=script&lang=js"
import style0 from "./Tiquete.vue?vue&type=style&index=0&id=9a994f2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports